// copy the above but do it for cancel-free-trial
import { CancelFreeTrialRequestBodyType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import {
  appSubscriptionKeys,
  organizationsKeys,
  subscriptionsKeys,
} from "../queryKeys";
import { ApiRequest } from "../types/api";

const cancelFreeTrial = async (
  payload: ApiRequest<CancelFreeTrialRequestBodyType>
) => {
  const resp = await api.post<any>(`/v2/organizations/cancel-free-trial`, {
    id: payload.body.id,
  });

  return resp.data;
};

export const useCancelFreeTrial = () => {
  const queryClient = useQueryClient();
  return useMutation<
    ApiRequest<CancelFreeTrialRequestBodyType>,
    Error,
    any,
    any
  >({
    mutationFn: async (payload: ApiRequest<CancelFreeTrialRequestBodyType>) =>
      cancelFreeTrial(payload),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: organizationsKeys.one });
      await queryClient.invalidateQueries({
        queryKey: appSubscriptionKeys.all,
      });
      await queryClient.invalidateQueries({
        queryKey: subscriptionsKeys.all(true),
      });
    },
  });
};
